import React from 'react';
import utils from "../common/utils";
import {Empty, Select, Table, DatePicker} from "antd";
import {Translation} from "react-i18next";
import moment from 'moment';
import 'moment/locale/vi'
import 'moment/locale/en-il'
import {ArrowRightOutlined, LinkOutlined} from '@ant-design/icons';
import { HiOutlineArrowNarrowRight } from 'react-icons/hi';
import consts from "../consts";

const {Option} = Select;
const {RangePicker} = DatePicker;

const DEPOSIT_TAB = 0
const WITHDRAW_TAB = 1
const dateFormat = 'DD/MM/YYYY';

const locale = {
  "lang": {
    "locale": "vi_VN",
    "placeholder": "Chọn ngày",
    "rangePlaceholder": ["Ngày bắt đầu", "Ngày kết thúc"],
    "today": "Hôm nay",
    "now": "Bây giờ",
    "backToToday": "Quay lại hôm nay",
    "ok": "Đồng ý",
    "clear": "Làm mới",
    "month": "Tháng",
    "year": "Năm",
    "timeSelect": "Chọn thời gian",
    "dateSelect": "Chọn ngày",
    "monthSelect": "Chọn tháng",
    "yearSelect": "Chọn năm",
    "decadeSelect": "Chọn thập kỷ",
    "yearFormat": "YYYY",
    "dateFormat": "M/D/YYYY",
    "dayFormat": "D",
    "dateTimeFormat": "M/D/YYYY HH:mm:ss",
    "monthFormat": "MMMM",
    "monthBeforeYear": true,
    "previousMonth": "Tháng trước (Trang trên)",
    "nextMonth": "Tháng sau (Trang dưới)",
    "previousYear": "Năm ngoái (Control + trái)",
    "nextYear": "Năm sau (Control + phải)",
    "previousDecade": "Thập kỷ vừa qua",
    "nextDecade": "Thập kỷ tới",
    "previousCentury": "Thế kỷ trước",
    "nextCentury": "Thế kỷ tới"
  },
  "timePickerLocale": {
    "placeholder": "Chọn thời gian"
  },
  "dateFormat": "YYYY-MM-DD",
  "dateTimeFormat": "YYYY-MM-DD HH:mm:ss",
  "weekFormat": "YYYY-wo",
  "monthFormat": "YYYY-MM"
}

class DepositAndWithdrawal extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      coin: undefined,
      tab: DEPOSIT_TAB,
      status: -1,
      currency: '',
      transType: -1,
      start: '',
      end: '',
      currentPage: 1,
    }
    
    this.fetchWithdrawalHistory = this.fetchWithdrawalHistory.bind(this);
    this.fetchDepositHistory = this.fetchDepositHistory.bind(this);
  }
  
  columns = (t) => [
    {
      align: "center",
      title: t('user.transaction.id'),
      width: 60,
      dataIndex: 'id',
    },
    {
      title: t('user.deposit_and_withdrawal.currency'),
      width: 150,
      dataIndex: 'currency',
      key: 'currency',
      render: this.getName,
    },
    {
      title: t('user.deposit_and_withdrawal.transfer'),
      width: 100,
      align: 'center',
      dataIndex: 'type',
      key: 'type',
      render: (type) => <div style={{color: type === consts.TRANSACTION_TYPE_DEPOSIT  ? "green" : "red"}}>
          { t(utils.parseTransType(type)) }
         </div>
    },
    // {
    //   align: "center",
    //   title: t('user.deposit_and_withdrawal.type'),
    //   width: 150,
    //   dataIndex: 'type',
    //   key: 'type',
    //   render: (type) => <div style={{color: utils.parseOrderTradeType(type) === "Sell" ? "green" : "red"}}>
    //     { t(utils.parseOrderTradeType(type))  }
    //   </div>
    // },
    {
      align: "center",
      title: t('user.deposit_and_withdrawal.fee'),
      width: 150,
      dataIndex: 'fee',
      key: 'fee',
      render: utils.formatCurrency
    },
    {
      align: "center",
      title: t('user.deposit_and_withdrawal.amount'),
      width: 150,
      dataIndex: 'amount',
      key: 'amount',
      render: utils.formatCurrency
    },
    {
      align: "center",
      title: t('user.deposit_and_withdrawal.status'),
      width: 200,
      dataIndex: 'status',
      key: 'status',
      render: (status) => t(utils.parseTranStatus(status))
    },
    {
      align: "center",
      title: t('user.deposit_and_withdrawal.deposit_and_withdrawal_date'),
      width: 200,
      dataIndex: 'created_at',
      key: 'created_at',
      render: (createdAt) => utils.formatTimeFromUnix(createdAt, 'DD/MM/YYYY HH:mm:ss'),
    },
    {
      align: "center",
      width: 100,
      title: t('user.withdrawal.detail'),
      dataIndex: 'tx_hash',
      key: 'tx_hash',
      render: (tx_hash, item) => this.getLink(tx_hash, item),
    },
  ]
  
  componentDidMount() {
    this.setState({coin: window._.first(window._.values(this.props.coins))});
    this.fetchDepositHistory(0, window.c.DEFAULT_PAGE_SIZE);
  }
  
  fetchTransaction = (pos, count) => {
    this.props.onFetchTransactionHistory({
        pos,
        count,
        trans_type: this.state.transType,
        status: parseInt(this.state.status),
        currency: this.state.currency,
        startTime: this.state.start,
        endTime: this.state.end,
      },
    );
  }
  
  getLink = (tx_hash, item) => {
    const { coins } = this.props;
    return (tx_hash && item.is_external ?
        <a className="fz-16" title={`${coins[item.currency]?.transaction_explorer}/tx/${tx_hash}`}
           href={`${coins[item.currency]?.transaction_explorer}/tx/${tx_hash}`} target="_blank">
          <LinkOutlined />
        </a> : ''
    )
  }
  
  fetchDepositHistory(pos, count) {
    this.setState({tab: DEPOSIT_TAB}, () => this.fetchTransaction(pos, count))
  }
  
  fetchWithdrawalHistory(pos, count) {
    this.setState({tab: WITHDRAW_TAB}, () => this.fetchTransaction(pos, count));
  }
  
  getName = (symbol) => {
    const {coins} = this.props;
    
    return <div className='d-flex'>
      <div style={{width: "45px", textAlign: "left"}}>
        <div style={{
          backgroundImage: `url(${coins[symbol]?.icon_image || ''})`,
          height: '26px',
          width: '26px',
          backgroundSize: 'contain',
          marginRight: "20px",
          display: 'block',
          backgroundRepeat: 'no-repeat',
          fontWeight: 600,
          color: 'black',
        }} alt={symbol} />
      </div>
      <div className="ellipsis" style={{width: "50px", textAlign: "left", fontWeight: "bold", lineHeight: '28px'}}>{symbol}</div>
      <div style={{
        width: "150px",
        textAlign: "left",
        fontSize: "12px",
        lineHeight: "28px",
        color: "#76808F",
      }}>{coins[symbol]?.name ?? ''}</div>
    </div>
  }
  
  onFetchDepositHistory = () => {
    this.fetchDepositHistory(0, window.c.DEFAULT_PAGE_SIZE)
  }
  onFetchWithdrawalHistory = () => {
    this.fetchWithdrawalHistory(0, window.c.DEFAULT_PAGE_SIZE)
  }
  
  onChange = (value) => {
    this.setState({
      transType: parseInt(value),
      currentPage: 1
    })
    { value === "1" ?  this.onFetchDepositHistory() : this.onFetchWithdrawalHistory()}
  }

  onChangeStatus = (status) => {
    this.setState({status, currentPage: 1}, () => this.fetchDepositHistory(0, window.c.DEFAULT_PAGE_SIZE));
  }
  
  onChangeCurrency = (currency) => {
    this.setState({currency, currentPage: 1}, () => this.fetchDepositHistory(0, window.c.DEFAULT_PAGE_SIZE));
  }

  onChangeDate = (date) => {
    if(date){
      this.setState({
        start:  date[0].startOf('day').unix(),
        end: date[1].endOf('day').unix(),
      }, () => this.fetchDepositHistory(0, window.c.DEFAULT_PAGE_SIZE))
    }
    else{
      this.setState({
        start: '',
        end: '',
        }, () => this.fetchDepositHistory(0, window.c.DEFAULT_PAGE_SIZE))
    }
    this.setState({currentPage: 1})
  }

  render() {
    const firstCoin = window._.first(window._.values(this.props.coins)) || {symbol: 'USDT'};
    const coinSymbol = window._.get(this.props.coin || firstCoin, 'symbol', '');
    
    return (
      <Translation>
        {(t) => <div className="depositandwithdrawal user-wallet">
          <div className="depositandwithdrawal-top">
            <div className='coin-container'>
              <div className='control'>
                <span className='label'> {t('user.deposit_and_withdrawal.transfer')} </span>
                <Select defaultValue='-1' onChange={this.onChange} className='coinSelect'>
                <Option value="-1">{t('user.deposit_and_withdrawal.all')} </Option>
                  <Option value="0">{t('user.deposit_and_withdrawal.deposits')}</Option>
                  <Option value="1">{t('user.deposit_and_withdrawal.withdrawal')}</Option>
                </Select>
              </div>
              
              
              <div className='control'>
                <span className='label'> {t('user.deposit_and_withdrawal.status')} </span>
                <Select defaultValue="-1" className='coinSelect' onChange={this.onChangeStatus}>
                  <Option value="-1">{t('user.deposit_and_withdrawal.all')} </Option>
                  <Option value="0">{t('user.deposit_and_withdrawal.success')} </Option>
                  <Option value="1">{t('user.deposit_and_withdrawal.pending')} </Option>
                  <Option value="2">{t('user.deposit_and_withdrawal.submitted')} </Option>
                  {/* <Option value="3">{t('user.deposit_and_withdrawal.error')} </Option> */}
                  <Option value="4">{t('user.deposit_and_withdrawal.cancel')} </Option>
                  {/* <Option value="5">{t('user.deposit_and_withdrawal.rejected')} </Option> */}
                </Select>
              </div>
              
              <div className='control'>
                <span className='label'> {t('user.deposit_and_withdrawal.coin')} </span>
                <Select
                  defaultValue=""
                  onChange={this.onChangeCurrency}
                  style={{width: 300}}
                  className='coinSelect'
                >
                  <Option key="all" value={""}>
                    {t('user.deposit_and_withdrawal.all')}
                  </Option>
                  {window._.map(window._.values(this.props.coins), (coin) => {
                    return <Option key={coin.symbol} value={`${coin.symbol}`}>
                      <div className="ln-big" className="d-flex space-between">
                        {this.getName(coin.symbol)}
                        {/* {coin.symbol}  */}
                      </div>
                    </Option>
                  })}
                </Select>
              </div>
              
              <div className='control'>
                <span className='label'> {t('user.deposit_and_withdrawal.deposit_and_withdrawal_date')} </span>
                <RangePicker className="date-picker1" format={'DD/MM/YYYY'}
                              separator={<HiOutlineArrowNarrowRight style={{fontSize: 11, marginRight: 10, color: 'rgba(0, 0, 0, 0.25)'}}/>}
                             disabledDate={(current) => current && current > moment().endOf('day')}
                             placeholder={[
                               t('user.deposit_and_withdrawal.deposit_and_withdrawal_start_date'),
                               t('user.deposit_and_withdrawal.deposit_and_withdrawal_end_date')
                             ]}
                             onChange={this.onChangeDate}
                />
              </div>
            </div>
          </div>
          <div className='depositandwithdrawal-top'>
            <Table
            
              locale={{emptyText: (<Empty description={<span className="bold">{window.$t('common.empty')}</span>}/>)}}
              columns={this.columns(t)}
              dataSource={window._.get(this.props.trans, 'withdrawalHistory', [])}
              pagination={{
                showQuickJumper: true,
                current: this.state.currentPage,
                defaultPageSize: window.c.DEFAULT_PAGE_SIZE,
                total: window._.get(this.props.trans, 'totalCount', 0),
                hideOnSinglePage: true,
                responsive: true,
                onChange: (page, pageSize) => {
                  if (this.state.tab === DEPOSIT_TAB) {
                    this.fetchDepositHistory((page - 1) * pageSize, pageSize);
                  } else {
                    this.fetchWithdrawalHistory((page - 1) * pageSize, pageSize)
                  }
                  this.setState({currentPage: page})
                }
              }}
              className='mb-large'
            />
          </div>
        
        </div>}
      </Translation>
    );
  }
}

export default DepositAndWithdrawal;
